const texts = {
  modalTitle: 'Repeat Workout Days',
  modalDescription: 'Enter the number of times to repeat the current workout days.',
  repeatCountLabel: 'Number of repetitions',
  repeat: 'Repeat',
  cancel: 'Cancel',
};

export default texts;
